import { Component, inject } from '@angular/core';
import { DialogContainerComponent } from '@components/admin/configurator/dialog-container/dialog-container.component';
import { BidiModule } from "@angular/cdk/bidi";
import { ViewerComponent } from '@views/viewer/viewer.component';
import { ButtonComponent } from "@components/shared/button/button.component";
import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { PreviewData } from '@services/conversor.service';

@Component({
    selector: 'app-site-preview',
    imports: [
        DialogContainerComponent,
        ViewerComponent,
        BidiModule,
        ButtonComponent
    ],
    templateUrl: './site-preview.component.html',
    styleUrl: './site-preview.component.css'
})
export class SitePreviewComponent {

  public readonly  data:    PreviewData = inject(DIALOG_DATA);
  private readonly dialog:  DialogRef   = inject(DialogRef);

  public loading: boolean = false;

  public import(open: boolean = false): void {
    
    this.loading = true;
    this.dialog.disableClose = true; 

    this.data.importConfig(this.data.id, open).subscribe({
      error: () =>  (this.loading = false, this.dialog.disableClose = false),
    });

  }

}
